// General
import "./video-call-settings-tutorial-dialog.scss";
import { useState, useEffect, forwardRef } from "react";
// Services
import { sessionService } from "../../../../services/session.service";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateVideoCallSettingsTutorialDialog } from "../../../../redux/store/dialogStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// Material UI
import { Dialog, Slide, useMediaQuery } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// i18next
import { useTranslation, Trans } from "react-i18next";
// Custom Hooks
import AssetManager from "../../../utility/manager/asset-manager/asset-manager";

const VideoCallSettingsTutorialDialog = () => {
  // General variables
  const [page, setPage] = useState(1);

  // Render variables
  let pageView;
  let titleView;
  let descriptionView;
  let backgroundImageView;

  // Redux variables
  const videoCallSettingsTutorialDialog = useSelector(
    (state) => state.dialog.videoCallSettingsTutorialDialog
  );
  const dispatch = useDispatch();

  // MUI variables
  const isMobile = useMediaQuery("(max-width: 720px)");

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const getAsset = AssetManager();

  // Lifecycle | Mounted
  useEffect(() => {
    if (!videoCallSettingsTutorialDialog) return;

    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-D34",
      },
    });
  }, [videoCallSettingsTutorialDialog]);

  // Event Handlers | Button
  const onPrevious = () => {
    setPage((prevPage) => {
      if (prevPage === 1) {
        return 1;
      }
      return prevPage - 1;
    });
  };
  const onNext = () => {
    setPage((prevPage) => {
      if (prevPage === 2) {
        return 2;
      }
      return prevPage + 1;
    });
  };

  // Event Handlers | MUI Dialog
  const onCloseDialog = (event, reason) => {
    if (reason === "backdropClick") return;

    // Save to local storage
    sessionService.setHasShownVideoCallSettingsTutorialDialog(true);
    dispatch(updateVideoCallSettingsTutorialDialog(false));
  };

  // Render Functions
  switch (page) {
    case 1:
      pageView = <div className="page-container">{page}/2</div>;
      titleView = (
        <div className="live-title">
          <Trans i18nKey="onboarding.call_availability_title" />
        </div>
      );
      descriptionView = (
        <div className="live-description">
          <Trans i18nKey="onboarding.call_availability_desc" />
        </div>
      );
      backgroundImageView = (
        <img
          className="live-background"
          src={getAsset("videoCallSettingsTutorial1Background")}
        />
      );
      break;
    case 2:
      pageView = <div className="page-container">{page}/2</div>;
      titleView = (
        <div className="live-title">
          <Trans i18nKey="onboarding.tipmenu_preset_title" />
        </div>
      );
      descriptionView = (
        <div className="live-description">
          <Trans i18nKey="onboarding.tipmenu_preset_desc" />
        </div>
      );
      backgroundImageView = (
        <img
          className="live-background"
          src={getAsset("videoCallSettingsTutorial2Background")}
        />
      );
      break;
    default:
      break;
  }

  return (
    <Dialog
      className={
        isMobile ? "custom-dialog-transparent" : "custom-radius35-dialog"
      }
      fullScreen={isMobile ? true : false}
      open={videoCallSettingsTutorialDialog}
      TransitionComponent={Transition}
      onClose={onCloseDialog}
    >
      <div
        id="video-call-settings-tutorial-dialog"
        className={isMobile ? "" : "max-width-container"}
      >
        <div className="header">
          <div className="close-button-container"></div>
        </div>

        <div className="padding-container">
          {pageView}

          {titleView}

          {descriptionView}

          <div className="live-background-container">
            <div className="arrow-back-icon-container" onClick={onPrevious}>
              {page !== 1 && <ArrowBackIosIcon />}
            </div>
            {backgroundImageView}

            <div className="arrow-forward-icon-container" onClick={onNext}>
              {page !== 2 && <ArrowForwardIosIcon />}
            </div>
          </div>
        </div>

        {page === 2 && (
          <div className="footer">
            <div className="done-button" onClick={onCloseDialog}>
              {t("common.done")}
            </div>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default VideoCallSettingsTutorialDialog;

// Render Functions | MUI Dialog | Will not work if inside of the same render as the Dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
